import { render } from "./Payment.vue?vue&type=template&id=3ca5c4da"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Payment.vue?vue&type=style&index=0&id=3ca5c4da&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__